/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './topo/topo.component.ngfactory';
import * as i3 from '../../app/topo/topo.component';
import * as i4 from '../../app/configs.service';
import * as i5 from '../../app/login/autentica.service';
import * as i6 from '@angular/router';
import * as i7 from '@angular/common';
import * as i8 from './rodape/rodape.component.ngfactory';
import * as i9 from '../../app/rodape/rodape.component';
import * as i10 from '../../app/app.component';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
function View_AppComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-topo',([] as any[]),
      (null as any),(null as any),(null as any),i2.View_TopoComponent_0,i2.RenderType_TopoComponent)),
      i1.ɵdid(114688,(null as any),0,i3.TopoComponent,[i4.ConfigsService,i5.AutenticaService,
          i6.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_AppComponent_1)),i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n\n'])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(212992,(null as any),0,i6.RouterOutlet,[i6.ChildrenOutletContexts,i1.ViewContainerRef,
          i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n\n'])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),1,'app-rodape',([] as any[]),(null as any),(null as any),
          (null as any),i8.View_RodapeComponent_0,i8.RenderType_RodapeComponent)),
      i1.ɵdid(114688,(null as any),0,i9.RodapeComponent,[i4.ConfigsService],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n\n']))],(_ck,_v) => {
    var _co:i10.AppComponent = _v.component;
    const currVal_0:any = _co.mostrarMenu;
    _ck(_v,1,0,currVal_0);
    _ck(_v,4,0);
    _ck(_v,7,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(114688,(null as any),0,i10.AppComponent,[i5.AutenticaService],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i10.AppComponent> = i1.ɵccf('app-root',
    i10.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2dpdGh1Yi93b3Jrc3BhY2Uvc3JjL2FwcC9hcHAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2dpdGh1Yi93b3Jrc3BhY2Uvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzIiwibmc6Ly8vZ2l0aHViL3dvcmtzcGFjZS9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2dpdGh1Yi93b3Jrc3BhY2Uvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzLkFwcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxhcHAtdG9wbyAqbmdJZj1cIm1vc3RyYXJNZW51XCI+PC9hcHAtdG9wbz5cblxuPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuXG48YXBwLXJvZGFwZT48L2FwcC1yb2RhcGU+XG5cbiIsIjxhcHAtcm9vdD48L2FwcC1yb290PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7YUFBQTttQkFBQTtJQUFBOzs7O29CQUFBO01BQUEsNkJBQUE7b0JBQUEsbUNBQXlDO01BQUEsV0FFekM7TUFBQTthQUFBO3NDQUFBO1VBQUEsZUFBK0IseUNBRS9CO1VBQUE7VUFBQTthQUFBO1VBQUEsZUFBeUI7O0lBSmY7SUFBVixXQUFVLFNBQVY7SUFFQTtJQUVBOzs7O29CQ0pBO01BQUE7YUFBQTtVQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts